import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { isMobileDevice } from './helpers/device';

export async function collectVisitorData(): Promise<Record<string, unknown>> {
  try {
    const entryUrl = window.location.href;
    const referrer = document.referrer;
    const timestamp = new Date().toISOString();

    const sessionId = getSessionId();
    const platform = isMobileDevice() ? 'mobile' : 'desktop';
    const fingerprint = await getFingerprint();
    const deviceInfo = getDeviceInfo();
    const utmParams = getUtmParams();

    return {
      entry_url: entryUrl,
      custom_session_id: sessionId,
      fingerprint,
      platform,
      referrer,
      timestamp,
      ...deviceInfo,
      ...utmParams
    };
  } catch (err) {
    console.error(err);
    return {};
  }
}

export const fingerprint = { visitorId: '' };
export async function getFingerprint() {
  // Проверяем наличие visitorId в sessionStorage
  let visitorId = sessionStorage.getItem('fingerprint_visitor_id');
  if (visitorId) {
    fingerprint.visitorId = visitorId;
    return visitorId;
  }

  try {
    const fp = await FingerprintJS.load();
    visitorId = (await fp.get()).visitorId;
    fingerprint.visitorId = visitorId;
    // Кешируем в sessionStorage
    sessionStorage.setItem('fingerprint_visitor_id', visitorId);
    return visitorId;
  } catch {
    return '';
  }
}

export function getSessionId() {
  let sessionId = sessionStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('session_id', sessionId);
  }
  return sessionId;
}

function getDeviceInfo() {
  const ua = navigator.userAgent;

  let os = 'Unknown';
  if (/Windows NT/i.test(ua)) os = 'Windows';
  else if (/Mac OS X/i.test(ua)) os = 'macOS';
  else if (/Android/i.test(ua)) os = 'Android';
  else if (/iPhone|iPad/i.test(ua)) os = 'iOS';
  else if (/Linux/i.test(ua)) os = 'Linux';

  let browser = 'Unknown';
  let browserVersion: string | null = null;

  if (/Chrome\/([\d.]+)/.test(ua)) {
    browser = 'Chrome';
    browserVersion = ua.match(/Chrome\/([\d.]+)/)?.[1] || null;
  } else if (/Firefox\/([\d.]+)/.test(ua)) {
    browser = 'Firefox';
    browserVersion = ua.match(/Firefox\/([\d.]+)/)?.[1] || null;
  } else if (/Safari\/([\d.]+)/.test(ua) && !/Chrome/.test(ua)) {
    browser = 'Safari';
    browserVersion = ua.match(/Version\/([\d.]+)/)?.[1] || null;
  } else if (/Edg\/([\d.]+)/.test(ua)) {
    browser = 'Edge';
    browserVersion = ua.match(/Edg\/([\d.]+)/)?.[1] || null;
  }

  return { os, browser, browser_version: browserVersion };
}

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',
  'fbclid',
  'yclid',
  'msclkid'
] as const;

type TUtmKey = (typeof UTM_KEYS)[number];
type TUtmParams = Partial<Record<TUtmKey, string>>;

export function getUtmParams(): TUtmParams {
  const stored = sessionStorage.getItem('utm_params');
  if (stored) {
    return JSON.parse(stored) as TUtmParams;
  }

  const params = new URLSearchParams(window.location.search);
  const result: TUtmParams = {};

  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) result[key] = value;
  }

  if (Object.keys(result).length > 0) {
    sessionStorage.setItem('utm_params', JSON.stringify(result));
  }

  return result;
}
